<template>
    <div class="lb-home lb-full-height has-scroll-y is-scroll-hidden">
        <home-slider />

        <!-- Why use labylok section -->
       <!-- <section class="hero is-large">
            <div class="hero-body py-6">
                <div class="container">
                    <h1
                        class="
                            is-size-2
                            has-text-centered
                            py-6
                            has-text-primary has-text-weight-bold
                        "
                    >
                        {{ $t('Home.why_use_labylok') }}
                    </h1>
                </div>
                <div class="container limited-width-60">
                    <figure class="image is-16by9">
                        <iframe
                            class="has-ratio"
                            width="640"
                            height="360"
                            :src="getVideoUrl"
                            frameborder="0"
                            allowfullscreen
                            title="YouTube video player"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        ></iframe>
                    </figure>
                </div>
            </div>
        </section>-->

        <!-- labylok project types section -->
        <section class="hero is-large has-background-pale-grey">
            <div class="hero-body py-6">
                <div class="container">
                    <h1
                        class="
                            is-size-2
                            has-text-centered
                            py-6
                            has-text-primary has-text-weight-bold
                        "
                    >
                        {{ $t('Home.choose_project_type_for_creation') }}
                    </h1>
                </div>
                <div class="container has-text-centered">
                    <creation-options
                        class="pb-6"
                        :showTitles="false"
                        :showButtons="canCreateProject"
                        @click="loadCreationTemplate"
                    />
                </div>
            </div>
        </section>

        <!-- Inspirations section -->
        <div
            class="inspirations-section"
            v-for="(inspiration, index) in featuredInspirations"
            :key="inspiration._id"
        >
            <div v-if="$mq != 'mobile'">
                <section class="hero is-large" v-if="!isOdd(index)">
                    <div class="hero-body py-6">
                        <div class="container">
                            <h1
                                class="
                                    is-size-2
                                    has-text-centered
                                    py-6
                                    has-text-black has-text-weight-bold
                                "
                            >
                                {{ $t('Home.inspire_with_singular_projects') }}
                            </h1>
                            <div class="container limited-width">
                                <div class="imagebox is-pulled-right">
                                    <figure class="image is-5by3 is-right">
                                        <img
                                            :src="inspiration.image.url"
                                            width="577px"
                                        />
                                    </figure>
                                </div>
                                <div class="is-overlay mt-6">
                                    <div class="box is-pulled-left">
                                        <p
                                            class="
                                                is-size-3
                                                has-text-black
                                                has-text-weight-bold
                                                px-4
                                                pb-3
                                            "
                                        >
                                            {{ inspiration.title }}
                                        </p>
                                        <p
                                            class="
                                                is-size-6
                                                has-text-black
                                                px-4
                                                is-clipped
                                            "
                                        >
                                            {{ inspiration.shortDescription }}
                                        </p>

                                        <router-link
                                            v-t="'Home.know_more'"
                                            :to="
                                                '/inspirations/' +
                                                inspiration._id
                                            "
                                            tag="button"
                                            class="
                                                lb-button
                                                is-uppercase
                                                mt-6
                                                is-ocean-blue
                                                px-6
                                                ml-4
                                                mb-4
                                            "
                                        ></router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="hero is-large" v-else>
                    <div class="hero-body py-6">
                        <div class="container">
                            <div class="container limited-width">
                                <div class="imagebox is-pulled-left">
                                    <figure class="image is-5by3 is-right">
                                        <img
                                            :src="inspiration.image.url"
                                            width="577px"
                                        />
                                    </figure>
                                </div>
                                <div class="is-overlay mt-6">
                                    <div class="box is-pulled-right">
                                        <p
                                            class="
                                                is-size-3
                                                has-text-black
                                                has-text-weight-bold
                                                px-4
                                                pb-3
                                            "
                                        >
                                            {{ inspiration.title }}
                                        </p>
                                        <p
                                            class="
                                                is-size-6
                                                has-text-black
                                                px-4
                                                is-clipped
                                            "
                                        >
                                            {{ inspiration.shortDescription }}
                                        </p>

                                        <router-link
                                            v-t="'Home.know_more'"
                                            :to="
                                                '/inspirations/' +
                                                inspiration._id
                                            "
                                            tag="button"
                                            class="
                                                lb-button
                                                is-uppercase
                                                mt-6
                                                is-ocean-blue
                                                px-6
                                                ml-4
                                                mb-4
                                            "
                                        ></router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="hero is-large">
                    <div class="has-text-centered pb-6">
                        <router-link
                            v-t="'Home.show_more_examples'"
                            :to="'/inspirations'"
                            tag="button"
                            class="
                                lb-button
                                is-uppercase is-very-light-pink
                                px-6
                                ml-4
                                has-text-primary
                            "
                        ></router-link>
                    </div>
                </section>
            </div>
            <div v-else class="">
                <div class="container">
                    <h1
                        class="
                            is-size-2
                            has-text-centered
                            pt-6
                            has-text-black has-text-weight-bold
                        "
                    >
                        {{ $t('Home.inspire_with_singular_projects') }}
                    </h1>
                    <div class="py-5 px-5" v-if="!isOdd(index)">
                        <div class="card my-5 mx-5">
                            <div class="card-image">
                                <figure class="image is-5by3">
                                    <img
                                        :src="inspiration.image.url"
                                        width="577px"
                                    />
                                </figure>
                            </div>
                            <div class="card-content">
                                <p
                                    class="
                                        is-size-3
                                        has-text-black has-text-weight-bold
                                        px-4
                                        pb-3
                                    "
                                >
                                    {{ inspiration.title }}
                                </p>
                                <p
                                    class="
                                        is-size-6
                                        has-text-black
                                        px-4
                                        is-clipped
                                    "
                                >
                                    {{ inspiration.shortDescription }}
                                </p>
                                <div class="has-text-centered">
                                    <router-link
                                        v-t="'Home.know_more'"
                                        :to="'/inspirations/' + inspiration._id"
                                        tag="button"
                                        class="
                                            lb-button
                                            is-uppercase
                                            mt-6
                                            is-ocean-blue
                                            px-6
                                            ml-4
                                            mb-4
                                        "
                                    ></router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="py-5 px-5" v-else>
                        <div class="card my-5 mx-5">
                            <div class="card-image">
                                <figure class="image is-5by3">
                                    <img
                                        :src="inspiration.image.url"
                                        width="577px"
                                    />
                                </figure>
                            </div>
                            <div class="card-content">
                                <p
                                    class="
                                        is-size-3
                                        has-text-black has-text-weight-bold
                                        px-4
                                        pb-3
                                    "
                                >
                                    {{ inspiration.title }}
                                </p>
                                <p
                                    class="
                                        is-size-6
                                        has-text-black
                                        px-4
                                        is-clipped
                                    "
                                >
                                    {{ inspiration.shortDescription }}
                                </p>
                                <div class="has-text-centered">
                                    <router-link
                                        v-t="'Home.know_more'"
                                        :to="'/inspirations/' + inspiration._id"
                                        tag="button"
                                        class="
                                            lb-button
                                            is-uppercase
                                            mt-6
                                            is-ocean-blue
                                            px-6
                                            ml-4
                                            mb-4
                                        "
                                    ></router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="has-text-centered pb-6">
                    <router-link
                        v-t="'Home.show_more_examples'"
                        :to="'/inspirations'"
                        tag="button"
                        class="
                            lb-button
                            is-uppercase is-very-light-pink
                            px-6
                            ml-4
                            has-text-primary
                        "
                    ></router-link>
                </div>
            </div>
        </div>

        <!-- How labylok works section -->
        <section class="hero is-large has-background-pale-grey">
            <div class="hero-body py-6">
                <div class="container">
                    <h1
                        class="
                            is-size-2
                            has-text-centered
                            py-6
                            has-text-primary has-text-weight-bold
                        "
                    >
                        {{ $t('Home.how_labylok_works') }}
                    </h1>
                </div>
                <div class="container limited-width">
                    <div class="columns">
                        <div class="column is-4">
                            <div class="card">
                                <div class="card-image">
                                    <figure
                                        class="
                                            image
                                            is-5by3
                                            has-background-primary
                                        "
                                    >
                                        <img
                                            :src="
                                                require(`@/assets/images/slider-home-1.png`)
                                            "
                                            width="577px"
                                        />
                                    </figure>
                                </div>
                                <div class="card-content">
                                    <p
                                        class="
                                            is-size-6
                                            has-text-primary
                                            has-text-weight-bold
                                            is-uppercase
                                            px-4
                                            pb-3
                                        "
                                    >
                                        {{ $t('Home.step_1') }}
                                    </p>
                                    <p
                                        class="
                                            is-size-4
                                            has-text-black has-text-weight-bold
                                            px-4
                                            pb-3
                                        "
                                    >
                                        {{ $t('Home.step_1_title') }}
                                    </p>
                                    <p class="is-size-6 has-text-black px-4">
                                        {{ $t('Home.step_1_content') }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="column is-4">
                            <div class="card">
                                <div class="card-image">
                                    <figure
                                        class="
                                            image
                                            is-5by3
                                            has-background-primary
                                        "
                                    >
                                        <img
                                            :src="
                                                require(`@/assets/images/slider-home-2.png`)
                                            "
                                            width="577px"
                                        />
                                    </figure>
                                </div>
                                <div class="card-content">
                                    <p
                                        class="
                                            is-size-6
                                            has-text-primary
                                            has-text-weight-bold
                                            is-uppercase
                                            px-4
                                            pb-3
                                        "
                                    >
                                        {{ $t('Home.step_2') }}
                                    </p>
                                    <p
                                        class="
                                            is-size-4
                                            has-text-black has-text-weight-bold
                                            px-4
                                            pb-3
                                        "
                                    >
                                        {{ $t('Home.step_2_title') }}
                                    </p>
                                    <p class="is-size-6 has-text-black px-4">
                                        {{ $t('Home.step_2_content') }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="column is-4">
                            <div class="card">
                                <div class="card-image">
                                    <figure
                                        class="
                                            image
                                            is-5by3
                                            has-background-primary
                                        "
                                    >
                                        <img
                                            :src="
                                                require(`@/assets/images/slider-home-3.png`)
                                            "
                                            width="577px"
                                        />
                                    </figure>
                                </div>
                                <div class="card-content">
                                    <p
                                        class="
                                            is-size-6
                                            has-text-primary
                                            has-text-weight-bold
                                            is-uppercase
                                            px-4
                                            pb-3
                                        "
                                    >
                                        {{ $t('Home.step_3') }}
                                    </p>
                                    <p
                                        class="
                                            is-size-4
                                            has-text-black has-text-weight-bold
                                            px-4
                                            pb-3
                                        "
                                    >
                                        {{ $t('Home.step_3_title') }}
                                    </p>
                                    <p class="is-size-6 has-text-black px-4">
                                        {{ $t('Home.step_3_content') }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!--
            <section class="hero is-large">
            <div class="hero-body py-6">
                <div class="container">
                    <h1
                        class="is-size-3 is-family-secondary has-text-centered pt-6"
                    >{{ $t('Home.featured_collections') }}</h1>
                    <app-project-skelleton v-if="fetchingProjects" :items="6" />
                    <home-projects-grid v-else :projects="collections" />
                </div>
            </div>
        </section>
        -->
        <!--
        <section class="hero is-large">
            <div class="hero-body py-6">
                <div class="container">
                    <h1
                        class="is-size-3 is-family-secondary has-text-centered pt-6"
                    >{{ $t('Home.featured_games') }}</h1>
                    <app-project-skelleton v-if="fetchingProjects" :items="6" />
                    <home-projects-grid v-else :projects="games" />
                </div>
            </div>
        </section>
        -->
        <!--
        <section class="hero has-background-prussian-blue is-bold">
        <div class="hero-body">
            <div class="container has-text-centered">
            <h1 
                v-t="'Home.explore_title'" 
                class="is-size-4 is-family-secondary has-text-white"></h1>
            <router-link
                v-t="'Home.go_to_explorer'"
                :to="'explore'"
                tag="button"
                class="lb-button is-uppercase mt-4"
            ></router-link>
            </div>
        </div>
            </section>-->
        <!--<home-community-section />-->
        <!--<home-school-section />-->
        <!--section class="hero is-large">
        <div class="hero-body pt-6">
            <div class="container">
            <h1
                v-t="'Home.devices_title'"
                class="title is-4 has-text-weight-bold has-text-centered"
            ></h1>
            </div>
        </div>
        </section>
        -->
        <footer class="footer has-background-prussian-blue has-text-centered">
            <div class="level is-mobile">
                <div class="level-left">
                    <div
                        v-t="'App.footer_project'"
                        class="level-item has-text-white"
                    ></div>
                </div>
                <div class="level-item is-hidden-mobile">
                    <p
                        class="
                            is-family-secondary
                            title
                            is-3 is-marginless
                            has-text-white
                        "
                    >
                        <img
                            src="@/assets/images/LabylokWhite.png"
                            alt
                            width="112"
                            height="28"
                        />
                    </p>
                </div>

                <div class="level-right">
                    <div class="level-item">
                        <router-link
                            v-t="'App.privacy_policy'"
                            :to="{ name: 'privacy' }"
                            class="has-text-white"
                        ></router-link>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import _ from 'underscore';
import HomeProjectsGrid from '@/components/HomeProjectsGrid';
import HomeSchoolSection from '@/components/HomeSchoolSection';
//import HomeCommunitySection from "@/components/HomeCommunitySection";
import HomeSlider from '@/components/HomeSlider';
import AppProjectSkelleton from '@/components/AppProjectSkelleton';
import { fetchFeaturedInspirations } from '@/services/API';
import CreationOptions from '@/components/CreationOptions';
export default {
    name: 'Home',
    components: {
        HomeProjectsGrid,
        HomeSchoolSection,
        //HomeCommunitySection,
        HomeSlider,
        AppProjectSkelleton,
        CreationOptions,
    },
    metaInfo() {
        // if no subcomponents specify a metaInfo.title, this title will be used
        return {
            title: 'Labylok',
            meta: [
                // Twitter Card
                { name: 'twitter:card', content: 'summary' },
                { name: 'twitter:title', content: 'Labylok' },
                {
                    name: 'twitter:description',
                    content: this.$t('slide_title_home'),
                },
                // image must be an absolute path
                {
                    name: 'twitter:image',
                    content: require(`@/assets/images/slider-home-1@2x.png`),
                },
                // Facebook OpenGraph
                { property: 'og:title', content: 'Labylok' },
                { property: 'og:site_name', content: 'Labylok' },
                { property: 'og:type', content: 'website' },
                {
                    property: 'og:image',
                    content: require(`@/assets/images/slider-home-1@2x.png`),
                },
                {
                    property: 'og:description',
                    content: this.$t('slide_title_home'),
                },
            ],
        };
    },
    data() {
        return {
            featuredInspirations: [],
            fetchingProjects: false,
            creating: false,
        };
    },
    computed: {
        location() {
            return location;
        },
        collections() {
            return _.filter(this.projects, (project) => {
                return project.type == 'collection';
            });
        },
        games() {
            return _.filter(this.projects, (project) => {
                return project.type == 'trivial';
            });
        },
        VUE_APP_ROOT_API() {
            return process.env.VUE_APP_ROOT_API;
        },
        getVideoUrl() {
            console.log(this.$i18n.locale);
            switch (this.$i18n.locale) {
                case 'ca-ES':
                    return 'https://www.youtube.com/embed/Bgh6OUoPzzI';
                case 'es':
                    return 'https://www.youtube.com/embed/O-Ie2FlXqFs';
                default:
                    return 'https://www.youtube.com/embed/O-Ie2FlXqFs';
            }
        },
        isAdmin() {
            return this.$store.getters.community.accessLevel == 'administrator';
        },
        canCreateProject() {
            return (
                this.$store.getters.isLoggedIn &&
                !this.$store.getters.isAnonymous
            );
        },
    },
    filters: {
        strippedContent: function (string) {
            const div = document.createElement('div');
            div.innerHTML = string;
            const text = div.textContent || div.innerText || '';
            return text;
        },
    },
    created() {
        //this.fetchingProjects = true;
        fetchFeaturedInspirations()
            .then(({ data }) => {
                this.featuredInspirations = data;
            })
            .finally(() => {
                //this.fetchingProjects = false;
            });
    },
    methods: {
        async login() {
            let loginURL = new URL(
                'https://accounts.google.com/o/oauth2/v2/auth'
            );
            let params = new URLSearchParams(loginURL.search.slice(1));
            params.append('access_type', 'offline');
            params.append('include_granted_scopes', true);
            params.append(
                'redirect_uri',
                process.env.VUE_APP_GOOGLE_REDIRECT_URI
            );
            params.append('client_id', process.env.VUE_APP_GOOGLE_CLIENT_ID);
            params.append('response_type', 'code');
            params.append('scope', 'email profile openid');
            params.append('prompt', 'consent');
            window.location = `${loginURL}?${params.toString()}`;

            return;

            await this.$gapi.grantOfflineAccess({
                redirect_uri: process.env.VUE_APP_GOOGLE_REDIRECT_URI,
            });
            this.$router.push({
                name: 'login',
                params: { code: this.$gapi.getOfflineAccessCode() },
            });
        },
        selectProjectType() {
            console.log(
                'selectProjectType',
                this.$store.getters.isLoggedIn,
                !this.$store.getters.isAnonymous
            );
            if (
                this.$store.getters.isLoggedIn &&
                !this.$store.getters.isAnonymous
            ) {
                console.log('to loadcreationtemplate');
                this.loadCreationTemplate;
            }
        },
        loadCreationTemplate: _.throttle(async function (type) {
            console.log('in loadCreationTemplate', this.creating);
            if (this.creating) {
                return;
            }

            let currentLocale = this.$i18n.locale;
            if (currentLocale == 'ca-ES') {
                currentLocale = 'ca';
            }

            let adjective = _.sample(
                this.$store.state[
                    'CREATION_ADJECTIVES_' +
                        type.type.toUpperCase() +
                        '_' +
                        currentLocale.toUpperCase()
                ],
                1
            );

            // let verb = _.sample(this.$store.state.CREATION_VERBS, 1);
            let verb = _.sample(
                this.$store.state[
                    'CREATION_VERBS_' + currentLocale.toUpperCase()
                ],
                1
            );

            this.creating = true;
            this.$Progress.start();
            let response = this.$store
                .dispatch('createProject', {
                    type: type.type,
                    title: `${this.$t(
                        type.name + '_creation_title_auto'
                    )} ${adjective}`,
                    description: `${this.$t(
                        'creation_description_auto'
                    )} ${verb}`,
                    mode: type.mode,
                })
                .then((response) => {
                    this.$router.push({
                        name: 'project',
                        params: { projectId: response.data._id },
                    });
                })
                .catch((e) => {
                    console.log('catch', e);
                    this.$Progress.fail();
                })
                .finally(() => {
                    this.creating = false;
                });
        }, 750),
        isOdd(index) {
            return index % 2;
        },
    },
};
</script>
<style scooped>
.inspirations-section .box {
    border-radius: 4px;
    box-shadow: 0 0 6px 0 rgb(0 0 0 / 50%);
    width: 33rem;
    top: 2rem;
    margin-left: 1rem;
}
.inspirations-section .imagebox {
    width: 46rem;
}
.container.limited-width {
    max-width: 75rem;
}
.card-content {
    padding-left: 1rem;
    padding-right: 1rem;
}
.container.limited-width-60 {
    max-width: 60rem;
}
.is-clipped {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    line-clamp: 4;
    -webkit-box-orient: vertical;
}
</style>
